import { ApiService } from '../../services/api.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'vq-file',
  templateUrl: './form-file.component.html',
  styles: []
})
export class FormFileComponent implements OnInit {

  @Input('vqModel') model:any;
	@Input('vqLabel') label:any;
  @Input('vqApiService') apiService:any;
	@Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();
  id:string;

  constructor(private _api:ApiService) { }

  ngOnInit() {
    this.setVqId();
  }

  private setVqId() {
    this.id = Math.random().toString(36).substr(2, 8);
  }

  public change($event) {
    let file = $event.srcElement.files[0]
    let fd = new FormData();
    fd.append('file', file, file.name);
  	this.modelChange.emit(fd)

    // if (this.apiService) {
    //   this._api.factory({
    //     endpoint: this.apiService,
    //     id : this.id,
    //     value : obj,
    //     success : (data) => {
    //   })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-file/form-file.component.ts